{
  "mini": 440,
  "xs": 500,
  "sm": 640,
  "md": 768,
  "big": 900,
  "lg": 1024,
  "xl": 1280,
  "2xl": 1536,
  "3xl": 2000
}
